module.exports = __webpack_public_path__ + "img/tg.50f9070b.svg";